import { renderPage } from "renderPage"
import { AccountAdvertShowPage } from "./Page"

renderPage({ component: AccountAdvertShowPage })
